/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlVerdict12 = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict12 = typeof ControlVerdict12[keyof typeof ControlVerdict12];


export function ControlVerdict12FromJSON(json: any): ControlVerdict12 {
    return ControlVerdict12FromJSONTyped(json, false);
}

export function ControlVerdict12FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict12 {
    return json as ControlVerdict12;
}

export function ControlVerdict12ToJSON(value?: ControlVerdict12 | null): any {
    return value as any;
}

